export const Table = (props) => {
  const { className, ...restProps } = props;
  return (
    <table {...restProps} className={`table ${className || ""}`}>
      {props.children}
    </table>
  );
};

export const TableHeader = (props) => {
  return <thead {...props}>{props.children}</thead>;
};
export const TableBody = (props) => {
  return <tbody {...props}>{props.children}</tbody>;
};
export const TableRow = (props) => {
  return <tr {...props}>{props.children}</tr>;
};
export const TableCell = (props) => {
  return <td {...props}>{props.children}</td>;
};
export const TableHead = (props) => {
  return <th {...props}>{props.children}</th>;
};
export const TableFoot = (props) => {
  return <tfoot {...props}>{props.children}</tfoot>;
};
export const NoRecordsFound = ({
  colSpan = 1,
  message = "No Record Found",
}) => {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-4 text-muted fw-semibold">
        {message}
      </td>
    </tr>
  );
};
